import { render, staticRenderFns } from "./project.vue?vue&type=template&id=2f52f656"
import script from "./project.vue?vue&type=script&lang=ts"
export * from "./project.vue?vue&type=script&lang=ts"
import style0 from "./project.vue?vue&type=style&index=0&id=2f52f656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports